import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import bookReducer from '../features/books/bookSlice';
import newsReducer from '../features/news/newsSlice';
import informationReducer from '../features/information/informationSlice';
import aboutReducer from '../features/about/aboutSlice';
import faqReducer from '../features/faqs/faqSlice';
import supportLogosReducer from '../features/supportLogos/supportLogosSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    books: bookReducer,
    news: newsReducer,
    information: informationReducer,
    about: aboutReducer,
    faqs: faqReducer,
    supportLogos: supportLogosReducer,
  },
});
